var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"py-3 m-0 wallpaper-secretario"},[_c('div',{directives:[{name:"scroll-reveal",rawName:"v-scroll-reveal"}],staticClass:"my-0 container"},[_c('msj-secretario',{attrs:{"verDato":_vm.verDato}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }